<script setup lang="ts">
import type { PropType } from "vue";
import type { UIColor } from "@align/ui";
import { type Location } from "~/helpers/entities/property-helpers";

type HeaderPortfolio = {
  id: string;
  name?: Nullable<string>;
};

type HeaderProperty = {
  id: string;
  name?: Nullable<string>;
  assetManagementPortfolio?: Nullable<HeaderPortfolio>;
};

type HeaderTenancy = Location & {
  id: string;
  assetManagementProperty?: Nullable<HeaderProperty>;
};

const props = defineProps({
  portfolio: {
    type: Object as PropType<HeaderPortfolio>,
    required: false,
  },

  property: {
    type: Object as PropType<HeaderProperty>,
    required: false,
  },

  tenancy: {
    type: Object as PropType<HeaderTenancy>,
    required: false,
  },

  colorBackground: {
    type: String as PropType<UIColor>,
    default: "--color-white",
  },

  colorForeground: {
    type: String as PropType<UIColor>,
    default: "--color-primary",
  },
});

const breadcrumbs = useBreadcrumbs().breadcrumbs;
</script>

<template>
  <Breadcrumbs :breadcrumbs="breadcrumbs" :colorForeground="colorForeground" :colorBackground="colorBackground" />
</template>
